import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGiftCardsQuery = createQueryHook(GiftCardsApiClient.getGiftCards, {
  queryKey: ['giftCards'],
})
